<og-auth-shell active="sign-in"
  ><section class="og-auth-form">
    <h2>Welcome back</h2>
    <p class="auth-description">Sign in to your Optimum Grading account.</p>
    <ng-container *ngIf="showAlert">
      <fuse-alert
        *ngFor="let alert of alerts"
        class="mt-8 -mb-4"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type"
        [@shake]="alert.type === 'error'"
      >
        {{ alert.message }}
      </fuse-alert>
    </ng-container>

    <form (ngSubmit)="signIn()" class="mt-8" [formGroup]="signInForm" #signInNgForm="ngForm">
      <mat-form-field subscriptSizing="dynamic" class="auth-full">
        <input
          aria-label="Email address or Username"
          placeholder="Email address or Username"
          id="email"
          autocomplete="username"
          matInput
          formControlName="email"
        />
        <mat-error *ngIf="signInForm.get('email').hasError('required')">
          Email / Username is required
        </mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="auth-full">
        <input
          aria-label="Password"
          placeholder="Password"
          id="password"
          matInput
          type="password"
          autocomplete="current-password"
          formControlName="password"
          #passwordField
        />
        <button
          aria-label="Toggle password visibility"
          mat-icon-button
          type="button"
          (click)="
            passwordField.type === 'password'
              ? (passwordField.type = 'text')
              : (passwordField.type = 'password')
          "
          matSuffix
        >
          <mat-icon
            class="icon-size-5"
            *ngIf="passwordField.type === 'password'"
            [svgIcon]="'heroicons_solid:eye'"
          ></mat-icon>
          <mat-icon
            class="icon-size-5"
            *ngIf="passwordField.type === 'text'"
            [svgIcon]="'heroicons_solid:eye-slash'"
          ></mat-icon>
        </button>
        <mat-error> Password is required </mat-error>
      </mat-form-field>

      <div class="inline-flex items-center justify-end w-full mt-1.5">
        <a
          class="text-md font-medium text-primary-500 hover:underline"
          routerLink="/authentication/forgot-password"
          >Forgot password?
        </a>
      </div>

      <button
        class="auth-submit"
        mat-flat-button
        [color]="'primary'"
        [disabled]="isLoading$ | async"
        type="submit"
      >
        <span *ngIf="!(isLoading$ | async)"> Sign in <span aria-hidden="true">→</span></span>
        <mat-progress-spinner
          *ngIf="isLoading$ | async"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </form>
    <p class="auth-footer">
      Don't have an account? <a routerLink="/authentication/sign-up">Sign up</a>
    </p>
  </section></og-auth-shell
>
